<template>
<v-flex>
    <h1 style="color: #969462 !important;">{{title}}</h1>
    <v-dialog v-model="loader" persistent width="350">
        <v-card color="#969462" dark>
            <v-card-text>
                A carregar ficheiros.<br>
                Por favor aguarde...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="deleteM" persistent max-width="390">
        <v-card>
            <v-card-title class="headline" style="margin-left: 0px !important;">Apagar ficheiro</v-card-title>
            <v-card-text>De certeza que quer apagar este ficheiro {{deleteF}}?</v-card-text>
            <v-card-actions style="margin-top: 0px !important;">
                <v-spacer></v-spacer>
                <v-btn color="#969462" flat="flat" @click.native="close">Cancelar</v-btn>
                <v-btn color="#969462" flat="flat" @click.native="deleteFile">Apagar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="clear" persistent max-width="390">
        <v-card>
            <v-card-title class="headline" style="margin-left: 0px !important;">Limpar pasta</v-card-title>
            <v-card-text>De certeza que quer eliminar todos os ficheiros da pasta uploads?</v-card-text>
            <v-card-actions style="margin-top: 0px !important;">
                <v-spacer></v-spacer>
                <v-btn color="#969462" flat="flat" @click.native="clear=false">Cancelar</v-btn>
                <v-btn color="#969462" flat="flat" @click.native="clearFolder">Apagar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-flex xs12 sm12 md12>
        <span v-for="(item, i) in items" :key="'i-'+i" @click="setPath(item.object, item.index)">
            <span class="target-object">{{item.text}}</span><span v-if="i<items.length-1"> > </span>
        </span>

        <v-btn color="#969462" flat="flat" icon @click.native="sync"><v-icon>refresh</v-icon></v-btn>
    </v-flex>
    <v-flex xs12 sm12 md12>
        <v-flex v-if="$route.name == 'uploads' || (items && items.findIndex((el)=>{ return el.text == 'uploads' }) > -1)" xs12 sm12 md12>
            <v-form ref="docForm">
                <div class="file-input multiple">
                    <div class="file-input-wrapper">
                        <input type="file" multiple id="single-example" readonly ref="doc" @change="onDocChange">

                        <label for="single-example" class="upload-cta">
                            Clique aqui ou arraste os ficheiros que pretende carregar
                        </label>
                    </div>
                </div>
            </v-form>
        </v-flex>
        <v-flex class="download-div" v-if="$route.name == 'uploads' || (items && items.findIndex((el)=>{ return el.text == 'uploads' }) > -1)">
            <v-btn v-if="OBJECT!=null" color="#969462" dark @click.native="download">Descarregar todos</v-btn>
            <v-btn v-if="getSession.user.super && OBJECT!=null" color="#969462" dark @click.native="clear = true">Limpar pasta</v-btn>
        </v-flex>
    </v-flex>
    <v-flex xs12 sm12 md12>
        <v-layout v-if="OBJECT!=null" row wrap style="display: flex; align-items: baseline; margin-top: 50px;">
            <div class="square noselect" @contextmenu="deleteI(OBJECT[item])" v-for="(item, i) in Object.keys(OBJECT)" :key="i" @click="setObject(OBJECT[item], item, typeof OBJECT[item] === 'object' || Array.isArray(OBJECT[item]))">
                <div class="item-object" v-if="typeof OBJECT[item] === 'object' || Array.isArray(OBJECT[item])">
                    <span>
                        <v-icon color="amber">folder</v-icon>
                    </span>
                    <span>
                        <p>{{item}}</p>
                    </span>
                </div>
                <div class="item-object" v-else>
                    <span>
                        <v-icon color="primary">description</v-icon>
                    </span>
                    <span>
                        <p>{{OBJECT[item]}}</p>
                    </span>
                </div>
            </div>
        </v-layout>
    </v-flex>
</v-flex>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";
const cName = {
    upper: "Documentos",
    lower: "o documento!"
};

export default {
    data: () => ({
        clear: false,
        deleteM: false,
        loader: false,
        menuItems: ["Apagar"],
        table: 'documentos',
        name: 'documento',
        DATA: [],
        OBJECT: null,
        raw: '',
        cliente: null,
        deleteF: '',
        items: [{
            text: 'Início',
            object: null,
            index: 0
        }],
        defaultItems: [{
            text: 'Início',
            object: null,
            index: 0
        }],
        messages: {
            add: {
                success: cName.upper + " criado com sucesso!",
                error: "Ocorreu um erro ao criar " + cName.lower
            },
            update: {
                success: cName.upper + " alterado com sucesso!",
                error: "Ocorreu um erro ao alterar " + cName.lower
            },
            delete: {
                success: cName.upper + " eliminado com sucesso!",
                error: "Ocorreu um erro ao apagar " + cName.lower
            },
            default: {
                sucesso: "Sucesso",
                error: "Ocorreu um erro!"
            }
        }
    }),

    computed: {
        ...mapGetters({
            getSession: 'session/getState',
            getAll: 'documentos/getAll'
        }),
        title(){
            if(this.$route.name == 'uploads') return 'Uploads'
            else if(this.$route.name == 'relatoriosgestao') return 'Relatórios de Gestão - Nova versão'
            else return 'Documentos'
        }
    },

    watch: {
        getAll(val) {
            if (this.items.length == 1 || this.$route.name == 'uploads' || this.$route.name == 'relatoriosgestao') this.initialize();
        },
    },
    created() {
        this.initialize();

        if (process.env.NODE_ENV != 'development') window.addEventListener('contextmenu', event => event.preventDefault());
    },
    mounted() {

    },
    methods: {
        toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },

        download() {
            var cliente = this.getSession.user.super ? this.cliente : this.getSession.user.codigo;

            this.$store.dispatch('documentos/download', cliente).then((res) => {
                if (res != false) {
                    window.open(this.$apiURL + res, '_blank');
                }
            });
        },

        clearFolder() {
            var cliente = this.getSession.user.super ? this.cliente : this.getSession.user.codigo;

            this.$store.dispatch('documentos/clear', cliente).then((res) => {

                if(res) {
                    this.OBJECT = [];
                    this.items.find((el) => {
                        return el.text == 'uploads'
                    }).object = [];
                    this.items[1].object.uploads = [];

                    setTimeout(() => {
                        this.$forceUpdate();
                    }, 500);

                    this.toast('success', 'Ficheiros apagados com sucesso!');
                }
                else this.toast('error', 'Ocorreu um erro ao apagar os ficheiros!');

                this.clear = false;
            });
        },

        close() {
            this.deleteM = false;
            setTimeout(() => {
                this.deleteF = null;
            }, 110);
        },

        onDocChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;

            this.loader = true;

            var cliente = this.getSession.user.super ? this.cliente : this.getSession.user.codigo;

            for (var d of files) {
                this.$store.dispatch('documentos/upload', [cliente, d]).then((res) => {
                    if (res) {
                        this.OBJECT = res;
                        this.items.find((el) => {
                            return el.text == 'uploads'
                        }).object = this.OBJECT;
                    } else this.toast('error', 'Ocorreu um erro ao submeter o ficheiro!');
                });

            }

            setTimeout(() => {

                this.$forceUpdate();
                this.toast('success', 'Ficheiros carregados com sucesso!');

                this.$refs.docForm.reset();
                this.loader = false;
            }, 500)

        },

        sync() {
            if (this.getSession.user.super == 0) this.$store.dispatch("documentos/get").then((res)=>{  this.toast('success', 'Lista de documentos atualizada.') });
            else this.$store.dispatch("documentos/getAllUsers").then((res)=>{  this.toast('success', 'Lista de documentos atualizada.') });
        },

        deleteI(item, state) {

            if (this.getSession.user.super == 0 || this.items[this.items.length - 1].text != 'uploads') return;

            this.deleteF = item;
            this.deleteM = true;
        },

        deleteFile() {
            if (this.getSession.user.super == 0) return;

            var array = [].concat(this.items);
            array.shift();

            var path = '/' + this.getSession.user.codigo + '/' + array.map((el) => {
                return el.text
            }).join('/') + '/';

            this.$store.dispatch('documentos/delete', {
                path: path,
                file: this.deleteF
            }).then((res) => {
                this.OBJECT = res;
                this.items.find((el) => {
                    return el.text == 'uploads'
                }).object = this.OBJECT;

                this.toast('success', 'Ficheiro apagado com sucesso!');
                this.$forceUpdate();

                setTimeout(() => {
                    this.deleteM = false;
                    this.deleteF = '';
                }, 110)

            });
        },

        setPath(object, index) {

            if (index == 0) {
                this.items = [].concat(this.defaultItems);
                this.OBJECT = this.getAll;
            } else {
                this.items = this.items.filter((el) => {
                    return el.index < index + 1
                });
                this.OBJECT = object;
            }
        },

        setObject(item, path, state) {
            if (state) {
                this.items.push({
                    text: path,
                    object: item,
                    index: this.items.length
                });

                if (this.getSession.user.super && this.items.length == 2) this.cliente = this.items[1].text;

                this.OBJECT = item;
            } else {
                var array = [].concat(this.items);
                array.shift();

                var path = array.length == 1 ? this.$fileURL + this.getSession.user.codigo + '/' + array.map((el) => {
                    return el.text
                }).join('/') + '/' + item : this.$fileURL + this.getSession.user.codigo + array.map((el) => {
                    return el.text
                }).join('/') + '/' + item;

                window.open(path, '_blank');

            }
        },

        /*orderKeys(obj) {

            var keys = Object.keys(obj).sort(function keyOrder(k1, k2) {
                if (k1 < k2) return -1;
                else if (k1 > k2) return +1;
                else return 0;
            });

            var i, after = {};
            for (i = 0; i < keys.length; i++) {
                after[keys[i]] = obj[keys[i]];
                delete obj[keys[i]];
            }

            for (i = 0; i < keys.length; i++) {
                obj[keys[i]] = after[keys[i]];
            }
            return obj;
        }, */

        initialize() {
            var path = this.$route.name;
            this.items = (path == 'uploads' || path == 'relatoriosgestao') ? [] :[].concat(this.defaultItems);
            this.loading = true;
            var emfalta = '50.Em falta';

            if (this.getSession.user.super == 0 && path == 'documentos') {
                var array = Object.getOwnPropertyNames(this.getAll);

                for (var p of this.getSession.user.pastas.split(',')) {
                    var key = array.find((el)=>{ return el.split('.')[0] == p });

                    if (this.getAll.hasOwnProperty(String(key))) {
                        delete this.getAll[key];
                    }
                }

                if (this.getAll.hasOwnProperty(emfalta)) delete this.getAll[emfalta];
                this.OBJECT = this.getAll;
            }
            else if(this.getSession.user.super == 0 && path == 'uploads') {
                if (this.getAll.hasOwnProperty('uploads')) this.OBJECT = this.getAll['uploads'];
            }
            else if(this.getSession.user.super == 0 && path == 'relatoriosgestao') {
                if (this.getAll.hasOwnProperty('Relatórios Gestão')) this.OBJECT = this.getAll['Relatórios Gestão'];
            }
            else this.OBJECT = this.getAll;


            this.loading = false;
        },
    }
}
</script>

<style scoped>
.square {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
}

.item-object {
    display: grid;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.item-object span i {
    font-size: 40px !important;
}

.item-object span p {
    font-weight: 600 !important;
    width: 80px;
    word-break: break-all;
}

.target-object {
    color: #969462 !important;
    cursor: pointer !important;
    font-size: 15px !important;
}

.noselect {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.file-input .file-input-wrapper {
    position: relative;
}

.file-input input {
    cursor: pointer;
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.01;
    border: 0;
}

.file-input input:focus~.upload-cta {
    border-color: #0f3fd0;
}

.file-input .upload-cta {
    display: block;
    text-align: center;
    border: 1px dashed #b9b9b9;
    border-radius: 5px;
    padding: 40px 90px;
    max-width: 100%;
    line-height: 1.5;
    margin-bottom: 16px;
}

.file-input .upload-cta:before {
    display: block;
    width: 32px;
    height: 32px;
    margin: 0 auto 18px;
    background-size: contain;
    content: "";
    background-image: url('data:image/png;base64,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');
}

.download-div {
    display: flex;
    justify-content: flex-end;
    height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/Table_Documentos.vue